/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FilterType = {
    DATE: 'date',
    STRING: 'string',
    NUMBER: 'number',
    LIST: 'list',
    BOOLEAN: 'boolean'
} as const;
export type FilterType = typeof FilterType[keyof typeof FilterType];


export function instanceOfFilterType(value: any): boolean {
    for (const key in FilterType) {
        if (Object.prototype.hasOwnProperty.call(FilterType, key)) {
            if (FilterType[key as keyof typeof FilterType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FilterTypeFromJSON(json: any): FilterType {
    return FilterTypeFromJSONTyped(json, false);
}

export function FilterTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterType {
    return json as FilterType;
}

export function FilterTypeToJSON(value?: FilterType | null): any {
    return value as any;
}

export function FilterTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FilterType {
    return value as FilterType;
}

